import styled from "styled-components";

import { FormControlLabel, Grid } from "@material-ui/core";

const opensans = (props) => props.theme.fonts.opensans;
const secondary = (props) => props.theme.palette.secondary;
const montserrat = (props) => props.theme.fonts.montserrat;

export const HeaderAccordion = styled.div`
  width: 100%;
  .MuiChip-root {
    padding: 0;
    margin: 0;
    width: 100%;
  }
`;

export const Line = styled(Grid)`
  margin-bottom: 15px !important;
  margin-top: 5px !important;
`;

export const CheckItem = styled(FormControlLabel)`
  .MuiTypography-body1 {
    font-family: ${opensans}, "sans-serif";
  }
`;

export const Form = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  height: auto;
  width: 100%;
  padding: 10px;
`;

export const TableContent = styled.div`
  Table {
    min-width: 0px !important;
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        th {
          span {
            font-family: ${montserrat}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      tr {
        height: 0px !important;
      }
      td {
        font-family: ${montserrat}, sans-serif !important;
      }
    }
  }
`;
